import { Icon } from "@repo/ui/components/icon";
import { Button } from "@repo/ui/ui/button";
import { Card, CardContent } from "@repo/ui/ui/card";
import { createLink, Outlet, useLocation } from "@tanstack/react-router";

const ButtonLink = createLink(Button);

export const ConnectionLayout = () => {
  const location = useLocation();
  const type = location.pathname.split("/").pop();

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="font-semibold text-2xl">Setup connection</h1>
        <ButtonLink to="/settings/connections/new" variant="ghost">
          <Icon name="chevron-left" />
          Back
        </ButtonLink>
      </div>
      <section className="space-y-2">
        <h2 className="mx-2 text-muted-foreground text-sm">
          {type && type[0].toUpperCase() + type.slice(1).replace("_", " ")}
        </h2>
        <Card>
          <CardContent>
            <Outlet />
          </CardContent>
        </Card>
      </section>
    </>
  );
};
